import { combineReducers } from "redux";
import storeState from "./storeState";

export default combineReducers({ storeState });
